<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteMiningGroupConfirm(form)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("mining_groups.name_placeholder")' :danger="!$v.form.name" :danger-text="'Name is required'" v-model="form.name" :label='$t("mining_groups.name")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("mining_groups.razon_social_placeholder")' :danger="!$v.form.razon_social" :danger-text="'Business Name is required'" v-model="form.razon_social" :label='$t("mining_groups.razon_social")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("mining_groups.delivery_address_placeholder")' :danger="!$v.form.delivery_address" danger-text="'Delivery Address is required'" v-model="form.delivery_address" :label='$t("mining_groups.delivery_address")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label {{$t("quotations.comments")}}
          vm-textarea(v-model="form.comments" counter="100")
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('MiningGroups')

export default {
  name: 'ModalMiningGroups',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'miningGroupsCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('mining_groups.add') : this.$t('mining_groups.edit')
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      razon_social: {
        required
      },
      delivery_address: {
        required
      },
      comments: {
        maxLength: maxLength(100)
      }
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addMiningGroup',
      'editMiningGroup',
      'deleteMiningGroup',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.isAdd ? this.addMiningGroup(this.form) : this.editMiningGroup(this.form)
    },
    async deleteMiningGroupConfirm (miningGroup) {
      let t = this
      this.auxDeleteMiningGroup = () => {
        t.deleteMiningGroup(miningGroup)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(miningGroup.razon_social) }),
        accept: this.auxDeleteMiningGroup
      })
    },
    async getCatalog () {
      Object.keys(this.miningGroupsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
